const PersonalData = {
    firstName: "Manuja",
    lastName: "D. Kariyawasam",
    nickName:"<  MrManchi >",
    mobNo:"(+94) 77 3354 796",
    email:"manuja1bc@gmail.com",
    address:"Colombo, Sri Lanka",
    aboutMe:"I am a passionate computer engineer who is interested in learning and exploring new things in the field of computer engineering. I consider my self hardworking in innovative technical backgrounds and also, I am a well responsible, excellent team player, and coordinator eager to learn and develop with a team. Interested in Backend and frontend developmet, Cloud computing, Data management, ML and AI.",
    resumeLink:'https://drive.google.com/file/d/1BUcOkLN8BLSWeFBhApfrm9a9CsGm18RE/view?usp=sharing',
}
export const autoTypeData=['Data Eng. enthusiast', 'ML and AI enthusiast','Backend Developer','Frontend Developer'];
export default PersonalData;
